<template>
    <span
            :class="{
                'loading-placeholder': true,
                'image-loading-placeholder': true,
            }"
            :style="{
                width: styleWidth,
                height: styleHeight,
                borderRadius: circle ? '50% !important' : null,

             }"
    >&nbsp;</span>
</template>
<script>
    export default {
        name: 'ImageLoadingPlaceholder',
        props: {
            width: {
                type: [String, Number],
                required: false,
            },
            height: {
                type: [String, Number],
                required: false,
            },
            circle: {
                type: Boolean,
                default: false,
                required: false,
            },
            rounded: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        computed: {
            styleHeight: function () {
                if (!this.height) {
                    return null;
                }
                if (typeof this.height === "string") {
                    return this.height;
                }
                return this.height + 'px';

            },
            styleWidth: function () {
                if (!this.width) {
                    return null;
                }
                if (typeof this.width === "string") {
                    return this.width;
                }
                return this.width + 'px';

            }
        }
    }
</script>
